import React from "react";

const HeroSection = () => {
  return (
    <section
      id="home_wrapper"
      className="relative isolate overflow-hidden bg-gray-50 h-[700px] flex items-center"
    >
      {/* Background */}
      <div className="absolute inset-0 -z-10 bg-[linear-gradient(150deg,theme(colors.indigo.100),theme(colors.gray.50),white)]" />

      {/* Decorative SVGs */}
      <svg
        className="hidden md:block absolute left-10 bottom-10 w-40 h-40 opacity-20"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        fill="none"
      >
        <circle
          cx="100"
          cy="110"
          r="40"
          fill="url(#treeGradient)"
          className="animate-pulse"
        />
        <defs>
          <radialGradient id="treeGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#2551c1" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#cacdd42e" />
          </radialGradient>
        </defs>
      </svg>

      <svg
        className="hidden md:block absolute right-10 bottom-0 w-72 h-72 opacity-20"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        fill="none"
      >
        <circle
          cx="100"
          cy="110"
          r="40"
          fill="url(#treeGradient2)"
          className="animate-pulse"
        />
        <defs>
          <radialGradient id="treeGradient2" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#2551c1" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#cacdd42e" />
          </radialGradient>
        </defs>
      </svg>

      {/* Content */}
      <div className="relative mx-auto max-w-4xl p-6 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-gray-900">
          Welcome to{" "}
          <span className="text-indigo-700">NetFee ISP Billing Software</span>
        </h1>

        <p className="mt-6 text-gray-600 md:text-lg leading-relaxed">
          NetFee is an ISP billing software. You can use the software completely
          in Bengali and English. Manage your ISP business more easily and
          effectively with comprehensive management and billing solutions.
          Including complete business management options and many other features
          to ensure your business runs smoothly. NetFee helps you manage clients
          and incoming requests without hassle, bringing you all the modern
          features that make your operations efficient.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <a href="https://app.netfeebd.com/login">
            <button className="px-6 py-3 rounded-full bg-indigo-700 hover:bg-indigo-800 text-white font-medium transition">
              Admin Login
            </button>
          </a>
          <a href="https://customer.netfeebd.com">
            <button className="px-6 py-3 rounded-full bg-indigo-700 hover:bg-indigo-800 text-white font-medium transition">
              Customer Login
            </button>
          </a>
          <a href="https://app.netfeebd.com/register">
            <button className="px-6 py-3 rounded-full bg-white border border-indigo-700 text-indigo-700 hover:bg-indigo-50 font-medium transition">
              Sign Up for the trial
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
